var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-results width-100 display-flex flex-align-center pl-1"},[_vm._v("No data found")])
}
var staticRenderFns = []

export { render, staticRenderFns }